import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Footer } from '../components/landing/Footer.js';
import { NavBar } from '../components/shared/NavBar.js';

/** Public pages that follow the user's light/dark preference (unlike marketing landing pages). */
export function PublicLayout() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col bg-ig-bg-primary text-ig-text-primary">
      <a
        href="#public-main"
        className="sr-only z-[100] rounded-md bg-ig-bg-elevated px-4 py-2 text-body-14 text-ig-text-primary focus:not-sr-only focus:fixed focus:left-4 focus:top-4"
      >
        {t('common.skipToContent', { defaultValue: 'Skip to content' })}
      </a>
      <NavBar variant="app" showGuestLanguageButton />
      <main id="public-main" className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
